import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const taxRefundStatusEnum = createEnum({
    PENDING: ['pending', '待退税', 'default'],
    PROCESSING: ['processing', '退税中', 'processing'],
    REFUNDED: ['refunded', '已退税', 'success'],
});
export const TAX_REFUND_STATUSES = enumValues(taxRefundStatusEnum);
export const TAX_REFUND_STATUS_LABEL_MAP = enumLabelMap(taxRefundStatusEnum);
//# sourceMappingURL=tax-refund.js.map